import { BASE_UAPI_URL } from "@/constants/commonStrings.constant";
import { apiService } from "../api.service";
import { AxiosRequestConfig } from "axios";
import createQueryParams from "@/util/queryParams";

export type GetTemplatesParams = {
  /**
   * @type integer, int32
   */
  customerid: number;
};

export type GetMergeFieldMapParams = {
  /**
   * @type integer, int32
   */
  customerid: number;
};

export type PostNewTemplateParams = {
  template: File;
  customerId: number;
  templateName: string;
};

export type DownloadTemplateParams = {
  templateId: number;
};

export type DeleteTemplateParams = {
  templateId: number;
};

export type UpdateTemplateParams = {
  template?: File;
  customerId?: string;
  templateName?: string;
  templateId?: number | null;
  description?: string;
};

const NotificationService = () => {
  const getTemplates = async (
    params: GetTemplatesParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<unknown> => {

    const { customerid } = params;
    const search = createQueryParams(params);
    const requestId = `getTemplates_${Date.now()}`;

    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + `/gettemplate?templateid=0&customerid=${customerid}`,
      ...config,
      id: requestId,
    });

    return response.data;
  };

  const getMergeFieldMap = async (
    params: GetMergeFieldMapParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<unknown> => {

    const { customerid } = params;
    const search = createQueryParams(params);
    const requestId = `getMergeFieldMap_${Date.now()}`;

    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + `/getmergefieldmap${search}`,
      ...config,
      id: requestId,
    });

    return response.data;
  };

  const postNewTemplate = async ({
    data,
    onSuccess,
    onError,
  }: {
    data: any;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    console.log('formData', data)
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/createtemplate',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onSuccess,
      onError,
    });
  };

  const getDownloadByTemplateId = async ({
    templateId,
    onSuccess,
    onError,
  }: {
    templateId: number;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/downloadtemplate',
      params: {
        templateid: templateId,
      },
      responseType: 'arraybuffer',
      onSuccess,
      onError,
    });
  };

  const postModifyTemplate = async ({
    data,
    onSuccess,
    onError,
  }: {
    data: any;
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/updatetemplate',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onSuccess,
      onError,
    });
  };

  const deleteTemplate = async (
    params: DeleteTemplateParams,
    config?: Partial<AxiosRequestConfig>
  ): Promise<unknown> => {
    const { templateId } = params;
    const response = await apiService({
      method: 'post',
      url: BASE_UAPI_URL + `/deletetemplate?templateid=${templateId}`,
    });
    return response.data;
  };

  return {
    getTemplates,
    getMergeFieldMap,
    postNewTemplate,
    getDownloadByTemplateId,
    postModifyTemplate,
    deleteTemplate,
  }

};

export default NotificationService;
